export default "__VITE_ASSET__DWYboy4M__"